import { NavLink } from 'react-router-dom'
import { Icon } from '@iconify/react'

const AdminSidebar = ({ isOpen, onClose }) => {
  const navItems = [
    { icon: 'mdi:view-dashboard', label: 'Dashboard', path: '/admin/dashboard' },
    { icon: 'mdi:office-building', label: 'Companies & Users', path: '/admin/companies-and-users' },
    { icon: 'mdi:credit-card-outline', label: 'Subscriptions & Billings', path: '/admin/subscription-and-billings' },
    { icon: 'mdi:package-variant', label: 'Subscription Plans', path: '/admin/subscription-plans' },
    { icon: 'mdi:account-cog', label: 'Profile Settings', path: '/admin/profile-setting' },
  ]

  return (
    <>
      {/* Mobile/Tablet sidebar - hidden on lg screens and above */}
      <aside
        className={`fixed top-0 left-0 w-68 h-full bg-bg-sidebar border-r border-slate-800 text-text-primary p-4 flex flex-col overflow-y-auto shadow-2xl z-50 transform transition-transform duration-300 ease-in-out lg:hidden ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="pb-6 border-b border-border mb-4">
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center">
                <Icon icon="mdi:shield-crown" className="text-white text-xl" />
              </div>
              <span className="text-lg font-bold text-white">Super Admin</span>
            </div>
            <button
              onClick={onClose}
              className="p-2 text-slate-400 hover:text-white hover:bg-bg-sidebarSurface rounded-lg transition-colors"
              aria-label="Close menu"
            >
              <Icon icon="mdi:close" className="text-2xl" />
            </button>
          </div>
          <p className="text-xs text-[#60A4FA] text-center">
            Admin Dashboard
          </p>
        </div>

        <nav className="flex flex-col gap-1">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              onClick={onClose}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-3 text-sm font-medium rounded-lg transition-all duration-150 ${
                  isActive
                    ? 'bg-primary text-white'
                    : 'text-slate-300 hover:bg-bg-sidebarSurface hover:text-white hover:translate-x-1'
                }`
              }
            >
              <Icon icon={item.icon} className="text-xl w-5 text-center" />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
      </aside>

      {/* Desktop sidebar - visible on lg, xl, and 2xl screens */}
      <aside className="hidden lg:flex w-64 bg-bg-sidebar border-r border-slate-800 text-text-primary p-4 flex-col fixed h-screen overflow-y-auto shadow-2xl z-50">
        <div className="space-y-4 pb-4 border-b border-border mb-4">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center">
              <Icon icon="mdi:shield-crown" className="text-white text-xl" />
            </div>
            <span className="text-lg font-bold text-white">Super Admin</span>
          </div>
          <p className="text-xs text-[#60A4FA] mt-1 text-center">
            Admin Dashboard
          </p>
        </div>

        <nav className="flex flex-col gap-1">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-3 text-sm font-medium rounded-lg transition-all duration-150 ${
                  isActive
                    ? 'bg-primary text-white'
                    : 'text-slate-300 hover:bg-bg-sidebarSurface hover:text-white hover:translate-x-1'
                }`
              }
            >
              <Icon icon={item.icon} className="text-xl w-5 text-center" />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
      </aside>
    </>
  )
}

export default AdminSidebar
